/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Variant_CountInputs */

const vi_shop_group_variant_count = /** @type {(inputs: Shop_Group_Variant_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số loại`)
};

/**

* @param {Shop_Group_Variant_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_variant_count = /** @type {((inputs?: Shop_Group_Variant_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Variant_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_variant_count(inputs)
});